var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.is_live)?_c('div',[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4"})])
}]

export { render, staticRenderFns }